import { AfterViewInit, Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import * as Highcharts from 'highcharts/highstock';
import {MatTabsModule} from '@angular/material/tabs';
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PollResultService } from "../../poll-result.service";
import { format } from "path";
import { UserService } from "@teammood/shared/util/user";
import { ITeam } from "@teammood/team";

@Component({
    selector: "recurring-poll-result-trends-line-chart",
    templateUrl: "./recurring-poll-result-trends-line-chart.component.html",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatTabsModule,
        TranslateModule
    ]
})
export class RecurringPollResultTrendsLineChartComponent implements AfterViewInit {

    protected teams: ITeam[]

    @Input() series: any;
    @Input() dates: any;
    @Input() chartId: string;
    
    constructor() {}
    ngAfterViewInit(){
        Highcharts.chart('questionTrendsBarResult' + this.chartId, this.resultChartConfig(this.dates, this.series) as any)
    }

    resultChartConfig (dates, series, recurrenceType?) {
        function xAxisTickInterval() {
            switch(recurrenceType) {
                case 'weekly':
                    return 24 * 3600 * 1000 * 7;
                case 'monthly':
                    return 24 * 3600 * 1000 * 30;
            }
        }

        return {
            chart: {
                height: 250,
            },
            title:  {text: ''},
            xAxis: {
                categories: dates,
                type: 'datetime',
                dateTimeLabelFormats: {
                    day: "%a %e/%m"
                },
                title: {
                    text: null
                },
                crosshairs: {
                    color: 'black',
                    dashStyle: 'solid'
                },     
                startOnTick: true,
                endOnTick: true,
            },
            yAxis: {
                title: {
                    text: ''
                },
                min: 0,
                max: 5
            },
            
            series: [
                ...series
            ],
            tooltip: {
                enabled: true,
                shared: true,
                split: false,
                useHTML: true,
                crosshairs: true,
                hideDelay: 1000,
            },
        };
    }
}